export default __webpack_public_path__ + "static/Corprate_WhoWeAre_01-8488a2e39820532c5508dc7f7ac0955c.jpg";